import React from "react";
import classnames from 'classnames';
import _, { noop } from "lodash";
import { Button, Tag } from "antd";
import DashboardAPI from "restAPI/DashboardAPI";
import ArmorCodeGroupSelectionList from "./ArmorCodeGroupSelectionList";
import ArmorCodeGroupSelectionListV2 from "./ArmorCodeGroupSelectionList_V2";
import {
  ARMORCODE_GROUP_NONE_VALUE,
  renderGroups,
} from "utils/armorcodeGroupUtil";
import Vocabulary from "./Vocabulary";
import ACMiddleEllipsis from "ac-components/ac-middle-ellipsis/ACMiddleEllipsis";

class ColumnFilterGroups extends React.Component {
  cancelAPI = noop;
  constructor(props) {
    super(props);
    this.state = {
      selected: props.selectedKeys || [],
      allGroups: null,
      changed: false,
    };
    _.bindAll(this, "applyFilter", "onSelectionChange");
  }
  componentWillUnmount() {
    this.cancelAPI();
  }
  componentDidMount() {
    this.fetchGroups();
  }
  fetchGroups() {
    const { promise, cancel } = DashboardAPI.getAllFilteredGroups();
    promise.then((r) => this.setState({ allGroups: r.groups || [] }));
    this.cancelAPI = cancel;
  }
  componentDidUpdate(prevProps) {
    const { visible, selectedKeys } = this.props;
    if (prevProps.visible !== visible) {
      if (!visible) {
        this.setState({
          selected: [],
        });
      }
      if (visible) {
        this.setState({
          selected: [...selectedKeys],
          changed: false,
        });
      }
    }
  }
  applyFilter() {
    const { confirm, setSelectedKeys } = this.props;
    const { selected } = this.state;
    setSelectedKeys(_.isEmpty(selected) ? [] : [...selected]);
    confirm();
  }
  onSelectionChange(values) {
    this.setState({ selected: values, changed: true });
  }
  onGroupRemove(group) {
    const { selected } = this.state;
    this.setState({ selected: _.filter(selected, (value) => value !== group), changed: true });
  }
  render() {
    const { selected, allGroups } = this.state;

    const { visible, newVersion } = this.props;

    const listProps = {
      onChange: this.onSelectionChange,
      value: selected,
      visible,
      allGroups,
    };
    return (
      <div className={classnames("column-filter column-filter-width column-filter-group", { 'new-version': newVersion })}>
        {
          !newVersion ? (
              <div className="m-xs m-b-0">
                <ArmorCodeGroupSelectionList {...listProps} noneOption />
              </div>
            )
            :
            (
              <>
                <div className="column-filter-group-content">
                  <div className="column-filter-title">Select <Vocabulary name='group' /></div>
                  <ArmorCodeGroupSelectionListV2 {...listProps} noneOption />
                  {
                    !_.isEmpty(selected) ?
                      (
                        <div className="column-filter-selected-value-section">
                          <div className="column-filter-sub-title">
                            Selected <Vocabulary name='group' />
                          </div>
                          <div className="column-filter-selected-value-wrapper d-flex flex-wrap" style={{ gap: 6, overflow: 'auto', maxHeight: 260 }}>
                            {
                              selected.map((value, i) => (
                                <Tag
                                  key={i}
                                  className="column-filter-selected-value m-0 d-flex align-items-center text-ellipsis"
                                  style={{ fontSize: 13.75 }}
                                  closable
                                  onClose={() => this.onGroupRemove(value)}
                                >
                                  <ACMiddleEllipsis text={value} />
                                </Tag>
                              ))
                            }
                          </div>
                        </div>
                      )
                      :
                      null
                  }
                </div>
              </>
            )
        }
        <div className="ant-table-filter-dropdown-btns column-filter-footer-action-button-wrapper">
          <Button type="primary" size="small" onClick={this.applyFilter} disabled={!this.state.changed}>
            Apply
          </Button>
        </div>
      </div>
    );
  }
}

export default ColumnFilterGroups;

ColumnFilterGroups.filterLabelFormatter = (v) =>
  v === ARMORCODE_GROUP_NONE_VALUE ? `<None>` : renderGroups(v);
